import React, { FC, ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '@unbooking/ui-auth'

interface Props {
  children: ReactElement;
}

export const UnauthorizedRoute: FC<Props> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to='/' replace />;
  }

  return children;
};
